export default function ServicesFour(){
    return(
        <>
            <div className="services-area pt-120 pt-md-60 pt-xs-60 pb-100 pb-xs-30 home-4">
			<div className="container">
				<div className="rts-heading">
					<div className="title-inner">
						<div className="sub-text">Services</div>
						<div className="title">Services We Provide</div>
					</div>
				</div>
				<div className="row">
					<div className="col-xl-4 col-lg-6 col-md-6 col-sm-12">
						<div className="services-wraper">
							<div className="services-top">
								<div className="services-icon">
									<img src="assets/img/home-4/icon-1.png" alt="" />
								</div>
								<div className="services-title">
									<h2 className="title">Branding Design</h2>
								</div>
							</div>
							<div className="services-bottom">
								<p className="services-text">
									Voice and Data Systems are crucial to the success or failure of most businesses.
								</p>
							</div>
						</div>
					</div>
					<div className="col-xl-4 col-lg-6 col-md-6 col-sm-12">
						<div className="services-wraper">
							<div className="services-top">
								<div className="services-icon">
									<img src="assets/img/home-4/icon-2.png" alt="" />
								</div>
								<div className="services-title">
									<h2 className="title">Strategy</h2>
								</div>
							</div>
							<div className="services-bottom">
								<p className="services-text">
									Voice and Data Systems are crucial to the success or failure of most businesses.
								</p>
							</div>
						</div>
					</div>
					<div className="col-xl-4 col-lg-6 col-md-6 col-sm-12">
						<div className="services-wraper">
							<div className="services-top">
								<div className="services-icon">
									<img src="assets/img/home-4/icon-3.png" alt="" />
								</div>
								<div className="services-title">
									<h2 className="title">Web Development</h2>
								</div>
							</div>
							<div className="services-bottom">
								<p className="services-text">
									Voice and Data Systems are crucial to the success or failure of most businesses.
								</p>
							</div>
						</div>
					</div>
					<div className="col-xl-4 col-lg-6 col-md-6 col-sm-12">
						<div className="services-wraper">
							<div className="services-top">
								<div className="services-icon">
									<img src="assets/img/home-4/icon-4.png" alt="" />
								</div>
								<div className="services-title">
									<h2 className="title">E-Commerce</h2>
								</div>
							</div>
							<div className="services-bottom">
								<p className="services-text">
									Voice and Data Systems are crucial to the success or failure of most businesses.
								</p>
							</div>
						</div>
					</div>
					<div className="col-xl-4 col-lg-6 col-md-6 col-sm-12">
						<div className="services-wraper">
							<div className="services-top">
								<div className="services-icon">
									<img src="assets/img/home-4/icon-5.png" alt="" />
								</div>
								<div className="services-title">
									<h2 className="title">Web Design</h2>
								</div>
							</div>
							<div className="services-bottom">
								<p className="services-text">
									Voice and Data Systems are crucial to the success or failure of most businesses.
								</p>
							</div>
						</div>
					</div>
					<div className="col-xl-4 col-lg-6 col-md-6 col-sm-12">
						<div className="services-wraper">
							<div className="services-top">
								<div className="services-icon">
									<img src="assets/img/home-4/iocn-6.png" alt="" />
								</div>
								<div className="services-title">
									<h2 className="title">
										Social Media</h2>
								</div>
							</div>
							<div className="services-bottom">
								<p className="services-text">
									Voice and Data Systems are crucial to the success or failure of most businesses.
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
        </>
    )
}